<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
  >
    <path
      fill="currentColor"
      d="M9.004 7.574 16.57.01l1.421 1.422-7.565 7.564L18 16.57l-1.42 1.421-7.576-7.575L1.42 18 0 16.58l7.583-7.585L.01 1.421 1.43 0z"
    />
  </svg>
</template>
